import React, { useState, useEffect, useRef } from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import {
  Grid,
  Typography,
  TextField,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  Radio,
  FormLabel,
  MenuItem,
  FormGroup,
  Card,
  CardContent,
  FormHelperText,
} from "@mui/material";

import { DeleteOutline, Edit } from "@mui/icons-material";

//react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";

import { useTranslation } from "react-i18next";
import Constants from "../../../services/Constants";
import ProductsModal from "../../../services/ProtocolItemModal";
import { cellFocusEditor, dateEditor } from "../../../services/Common";

const ProtocolFormData = ({
  setFormData,
  formData,
  handleDetailDropDownChange,
  handleDetailChange,
  handleDetailCheck,
  productAdd,
  ...props
}) => {
  const permissionType = props.permissionType;
  console.log("permissionType: ", permissionType);
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const { t, i18n } = useTranslation();
  const ProtocolItemsRefHolder = useRef({ table: null });
  const ProtocolItemsRef = ProtocolItemsRefHolder.current;

  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "protocol";

  const IntervalList = JSON.parse(localStorage.getItem("IntervalList"));
  const DirectionList = JSON.parse(localStorage.getItem("DirectionList"));
  const Regimen_List = JSON.parse(localStorage.getItem("Regimen_List"));

  const [open, setOpen] = useState(false);

  const [manyTableData, setManyTableData] = useState([]);

  const protocolTypeList = [
    // {id: 'None', name: 'None'},
    { id: "None", name: DispensingLanguage[lan][menukey]["None"] },
    { id: "TLD", name: "TLD" },
    { id: "TLE", name: "TLE" },
  ];
  //console.log(protocolTypeList);

  const handleClose = (modalname) => {
    switch (modalname) {
      case "Products":
        setOpen(false);
        break;
      case "ProductsOpen":
        setOpen(true);
        break;

      default:
        break;
    }
  };

  const addProduct = (NonOrderProductData) => {
    console.log("NonOrderProductData: ", NonOrderProductData);

    let temNonordata = NonOrderProductData;
    let rows = [];

    let autoId = 0;
    temNonordata.forEach((row, i) => {
      autoId--;
      let newRow = {};

      newRow.id = autoId;
      newRow.ItemNo = row.ItemNo;
      newRow.ItemShortName = row.ItemShortName;
      newRow.type = "product"; //row.ItemCode;
      newRow.formulationQty = 1;
      newRow.UnitPrice = row.UnitPrice;
      newRow.UnitName = row.UnitName;
      newRow.AdministrationUnit = row.AdministrationUnit;
      newRow.intervalId = 1;
      newRow.dur = 1;
      newRow.rep = 0;
      newRow.calc = 0;
      newRow.product = row.ItemName;
      newRow.dispQty = 0;
      newRow.directionId = 1;
      newRow.packs = 0;
      newRow.bp = 0;
      newRow.ICDCode = "";
      newRow.productQty = 0;
      newRow.PacksizeName = row.PacksizeName;

      rows.push(newRow);
    });

    autoId = 0;
    manyTableData.forEach((row, i) => {
      autoId++;
      let newRow = {};

      newRow.id = autoId;
      newRow.ItemNo = row.ItemNo;
      newRow.ItemShortName = row.ItemShortName;
      newRow.type = row.type;
      newRow.formulationQty = row.formulationQty;
      newRow.UnitPrice = row.UnitPrice;
      newRow.UnitName = row.UnitName;
      newRow.AdministrationUnit = row.AdministrationUnit;
      newRow.intervalId = row.intervalId;
      newRow.dur = row.dur;
      newRow.rep = row.rep;
      newRow.calc = row.calc;
      newRow.product = row.product;
      newRow.dispQty = row.dispQty;
      newRow.directionId = row.directionId;
      newRow.packs = row.packs;

      newRow.bp = row.bp;
      newRow.ICDCode = row.ICDCode;
      newRow.productQty = row.productQty;
      newRow.PacksizeName = row.PacksizeName;

      rows.push(newRow);
    });

    console.log("rows after pick product: ", rows);

    setManyTableData(rows);
    productAdd(rows);
    handleClose("Products");
  };

  useEffect(() => {
    setManyTableData(formData.details);
    console.log("formData.details from useeffect: ", formData.details);
  }, [formData.details]);

  function RowInputData(props: any, type = null) {
    const rowData = props.cell._cell.row.data;
    let fieldName = props.field;
    let fieldType = props.fieldType;
    let labelName = props.labelName;
    let dropDownKey = props.dropDownKey;

    switch (fieldType) {
      case "text":
        return (
          <>
            <TextField variant="standard"
              id={fieldName}
              name={fieldName}
              type="number"
              value={rowData[fieldName]}
              fullWidth
              autoComplete="family-name"
              onChange={(e) => handleDetailChange(e, rowData)}
            />
          </>
        );
        break;

      case "drop-down-interval":
        return (
          <Select
            disabled={!!permissionType}
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            fullWidth
            name={fieldName}
            value={rowData[fieldName]}
            onChange={(e) => handleDetailDropDownChange(e, rowData)}
            variant="standard"
            disableUnderline
          >
            {IntervalList.map((item) => {
              return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
            })}
          </Select>
        );
        break;

      case "drop-down-direction":
        return (
          <Select
            disabled={!!permissionType}
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            fullWidth
            name={fieldName}
            value={rowData[fieldName]}
            onChange={(e) => handleDetailDropDownChange(e, rowData)}
            variant="standard"
            disableUnderline
          >
            {DirectionList.map((item) => {
              return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>;
            })}
          </Select>
        );
        break;

      case "check-box":
        return rowData.type == "protocol" && fieldName == "bp" ? (
          <></>
        ) : (
          <Checkbox
            color="primary"
            checked={!!rowData[fieldName]}
            onChange={(e) => handleDetailCheck(e, rowData)}
            name={fieldName}
            value={rowData[fieldName]}
          />
        );
        break;

      default:
        return <></>;
        break;
    }
    return <></>;
  }

  const ProtocolDetailsColumns = [
    { title: "ProtocolItemId", field: "ProtocolItemId", visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      width: 50,
      formatter: "rownum",
      hozAlign: "center",
      headerHozAlign: "center",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Description"]),
      field: "ItemShortName",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Qty"]),
      field: "formulationQty",
      width: 65,
      hozAlign: "right",
      headerHozAlign: "right",
      validator: ["integer", "min:0"],
      cssClass: "tabluator-column-editable",
      /* editor: cellFocusEditor,    */
      editor: permissionType == 0 ? cellFocusEditor : "",
      cellEdited: function (cell) {
        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const rowdata = currow.getData();
        const curcol = cell.getField();
        props.setUpdatedDetailsGridDataHandler(currow._row.data, curcol);
        //props.setUpdatedDetailsGridDataHandler(currow._row.data);
      },
    },

    {
      title: t(DispensingLanguage[lan][menukey]["UoM"]),
      field: "UnitName",
      width: 130,
    },

    {
      title: t(DispensingLanguage[lan][menukey]["UoM"]),
      field: "AdministrationUnit",
      width: 100,
      visible: false,
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Int"]),
      field: "intervalId",
      width: 130,
      formatter: reactFormatter(
        <RowInputData
          labelName="Int"
          field="intervalId"
          fieldType="drop-down-interval"
          dropDownKey="INTERVALS"
        />
      ),
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Dur"]),
      field: "dur",
      width: 80,
      hozAlign: "right",
      headerSort: false,
      // formatter: reactFormatter(
      //   <RowInputData labelName="Dur" field="dur" fieldType="text" />
      // ),
      validator: ["integer", "min:1"],
      cssClass: "tabluator-column-editable",
      // editor: bStockUpdate == 0 ? cellFocusEditor: '',
      /* editor: cellFocusEditor,   */
      editor: permissionType == 0 ? cellFocusEditor : "",
      cellEdited: function (cell) {
        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const curcol = cell.getField();
        const rowdata = currow.getData();
        // const pricecell = currow.getCell("LineTotal");
        // const totprice = rowdata.UnitPrice * curcellval;
        // pricecell.setValue(totprice);

        props.setUpdatedDetailsGridDataHandler(rowdata, curcol);

        //props.setUpdatedDetailsGridDataHandler(rowdata)

        // onChange={(e) => handleDetailChange(e, rowData)}

        // props.setUpdatedDetailsGridDataHandler(currow._row.data);
      },
    },
    /*
    { title: t(DispensingLanguage[lan][menukey]['Dur']), field: "dur", width: 65, hozAlign: "right", headerHozAlign:"right", 
      cssClass: "tabluator-column-editable",
      editor: cellFocusEditor,      
      cellEdited: function (cell) {
        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const rowdata = currow.getData(); 
        props.setUpdatedDetailsGridDataHandler(rowdata);
      }
    },
    */
    {
      title: t(DispensingLanguage[lan][menukey]["Calc"]),
      field: "calc",
      width: 80,
      hozAlign: "right",
      headerHozAlign: "right",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Name"]),
      field: "product",
      visible: false,
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Packs"]),
      field: "packs",
      width: 80,
      hozAlign: "right",
      headerHozAlign: "right",
      cssClass: "tabluator-column-editable",
      /* editor: cellFocusEditor, */
      editor: permissionType == 0 ? cellFocusEditor : "",
      cellEdited: function (cell) {
        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const rowdata = currow.getData();
        const curcol = cell.getField();
        // props.setUpdatedDetailsGridDataHandler(rowdata);
        props.setUpdatedDetailsGridDataHandler(rowdata, curcol);
      },
      visible: false,
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Qty"]),
      field: "productQty",
      width: 65,
      hozAlign: "right",
      headerHozAlign: "right",
      visible: false,
    },

    {
      title: t(DispensingLanguage[lan][menukey]["Dir"]),
      field: "directionId",
      width: 220,
      formatter: reactFormatter(
        <RowInputData
          labelName="Dir"
          field="directionId"
          fieldType="drop-down-direction"
          dropDownKey="DIRECTIONS"
        />
      ),
    },

    {
      title: t(DispensingLanguage[lan][menukey]["BP"]),
      field: "bp",
      width: 50,
      hozAlign: "center",
      vertAlign: "middle",
      cssClass: "tabluator-column-editable",
      formatter: reactFormatter(
        <RowInputData labelName="BP" field="bp" fieldType="check-box" />
      ),
      editor: true,
      cellEdited: function (cell) {
        const curcellval = cell.getValue();
        const currow = cell.getRow();
        const rowdata = currow.getData();
        props.setUpdatedDetailsGridDataHandler(rowdata);
      },
      visible: false,
    },
    {
      // title: t(DispensingLanguage[lan][menukey]["Pcks"]),
      title: "Pack Size",
      field: "PacksizeName",
      hozAlign: "right",
      headerHozAlign: "right",
      width: 60,
      visible: false,
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      field: "custom",
      headerSort: false,
      headerHozAlign: "center",
      hozAlign: "center",
      width: 100,
      formatter: reactFormatter(<ActionButton />),
    },

    /*{ 
    title: t(DispensingLanguage[lan][menukey]['Actions']), 
    field: 'custom', headerSort:false, headerHozAlign:"center", hozAlign: 'center',width: 100,
     formatter: reactFormatter(<ActionButton />) }

     */
  ];

  const ProtocolDetailsDataItems = manyTableData?.map((item, index) => {
    // item["LineTotal"] = item.Quantity * item.UnitPrice;
    return item;
  });

  const deleteProtocolItems = (data) => {
    props.deleteProtocolItems(data);
  };

  function ActionButton(props) {
    const rowData = props.cell._cell.row.data;
    //console.log("RRRR",rowData);
    const cellValue = props.cell._cell.value || "Edit | Show";
    if (permissionType) return <></>;
    else
      return (
        <>
          <DeleteOutline
            onClick={() => {
              deleteProtocolItems(rowData);
            }}
          />
        </>
      );
  }

  return (
    <div className={classes.productPageTitle}>
      <div className="sw_makeStyles_tableContainer">
        <div className="d-flex justify-product mb-3">
          <Grid container>
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {DispensingLanguage[lan][menukey]["Protocol Entry - Add/Edit"]}
              </div>

              <div className="float-end sw_btn_control">
                {props.addProductForm ? (
                  <Grid item xs={12} className="mt-4 text-center">
                    <div className="float-end sw_btn_control">
                      <Button
                        disabled={!!permissionType}
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() => props.handleReset()}
                      >
                        {DispensingLanguage[lan][menukey]["Reset"]}
                      </Button>
                      <Button
                        disabled={!!permissionType}
                        className="me-2"
                        variant="contained"
                        color="primary"
                        onClick={() => props.handleSubmit()}
                      >
                        {DispensingLanguage[lan][menukey]["Save"]}
                      </Button>
                      <Button
                        className="me-2"
                        variant="contained"
                        color="gray"
                        type="reset"
                        onClick={() => props.history.push("/protocol")}
                      >
                        {DispensingLanguage[lan][menukey]["Back to List"]}
                      </Button>
                    </div>
                  </Grid>
                ) : (
                  <Grid item xs={12} className="mt-2 text-center">
                    <Button
                      disabled={!!permissionType}
                      className="me-2"
                      variant="contained"
                      color="primary"
                      onClick={() => props.handleUpdate()}
                    >
                      {DispensingLanguage[lan][menukey]["update"]}
                    </Button>

                    <Button
                      className="me-2"
                      variant="contained"
                      color="gray"
                      type="reset"
                      onClick={() => props.history.push("/protocol")}
                    >
                      {DispensingLanguage[lan][menukey]["Back to List"]}
                    </Button>
                  </Grid>
                )}
              </div>
            </div>
          </Grid>
          </Grid>
        </div>

            <Grid container spacing={2} alignItems="flex-end">
              <Grid item xs={3} sm={2}>
                <TextField variant="standard"
                  error={!!props.errorObject.code}
                  helperText={props.errorObject.code}
                  required
                  disabled
                  id="code"
                  name="code"
                  label={DispensingLanguage[lan][menukey]["Code"]}
                  value={formData.code}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => props.handleChange(e)}
                />
              </Grid>

              <Grid item xs={4} sm={3}>
                <FormControl variant="standard" className={classes.fullWidth}>
                  <InputLabel id="demo-simple-select-helper-label">
                    {DispensingLanguage[lan][menukey]["Regimen"]}*
                  </InputLabel>
                  <Select
                    disabled={!!permissionType}
                    error={!!props.errorObject.RegimenId}
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    name="RegimenId"
                    value={formData.RegimenId}
                    fullWidth
                    onChange={(e) => props.handleChange(e)}
                  label={`${DispensingLanguage[lan][menukey]["Regimen"]} *`}>
                    {Regimen_List.map((item, index) => {
                      return (
                        <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                      );
                    })}
                  </Select>
                  {props.errorObject.RegimenId && (
                    <FormHelperText error>{props.errorObject.RegimenId}</FormHelperText>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={3} sm={3}>
                <TextField variant="standard"
                  disabled={!!permissionType}
                  error={!!props.errorObject.protocolName}
                  helperText={props.errorObject.protocolName}
                  required
                  id="protocolName"
                  name="protocolName"
                  label={DispensingLanguage[lan][menukey]["Protocol Name"]}
                  value={formData.protocolName}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => props.handleChange(e)}
                />
              </Grid>

              <Grid item xs={3} sm={2}>
                <TextField variant="standard"
                  disabled={!!permissionType}
                  error={!!props.errorObject.protocolShortName}
                  helperText={props.errorObject.protocolShortName}
                  id="protocolShortName"
                  name="protocolShortName"
                  label={
                    DispensingLanguage[lan][menukey]["Protocol Short Name"]
                  }
                  value={formData.protocolShortName}
                  fullWidth
                  autoComplete="family-name"
                  onChange={(e) => props.handleChange(e)}
                />
              </Grid>
              {/* protocol type */}
              <Grid item xs={4} sm={2}>
                <FormControl variant="standard" className={classes.fullWidth}>
                  <InputLabel id="demo-simple-select-helper-label">
                    {DispensingLanguage[lan][menukey]["ProtocolType"]}*
                  </InputLabel>
                  <Select
                    disabled={!!permissionType}
                    error={!!props.errorObject.protocolType}
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    name="protocolType"
                    value={formData.protocolType}
                    fullWidth
                    onChange={(e) => props.handleChange(e)}
                  label={`${DispensingLanguage[lan][menukey]["ProtocolType"]} *`}>
                    {protocolTypeList.map((item, index) => {
                      return (
                        <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                      );
                    })}
                  </Select>
                  {props.errorObject.protocolType && (
                    <FormHelperText error>{props.errorObject.protocolType}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={3} sm={3}>
                <TextField variant="standard"
                  disabled={!!permissionType}
                  id="ProtocolId"
                  name="ProtocolId"
                  label="ProtocolId"
                  value={formData.ProtocolId || ""}
                  fullWidth
                  hidden
                  autoComplete="family-name"
                />
              </Grid>
            </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <Card className="sw_card">
                    <CardContent>
                      <Grid container className="mb-2">
                        <Grid item xs={12} sm={12}>
                          <div className="float-end sw_btn_control">
                            <Button
                              disabled={!!permissionType}
                              className="me-2"
                              variant="contained"
                              color="primary"
                              onClick={() => handleClose("ProductsOpen")}
                            >
                              {
                                DispensingLanguage[lan][menukey][
                                  "SELECT PRODUCT"
                                ]
                              }
                            </Button>
                          </div>
                          <ProductsModal
                            handleClose={handleClose}
                            open={open}
                            addProduct={addProduct}
                            {...props}
                          />
                        </Grid>
                      </Grid>
                      <ReactTabulator
                        onRef={(r) => { ProtocolItemsRef.table = r.current; }}
                        columns={ProtocolDetailsColumns}
                        data={manyTableData}
                        height="350px"
                        layout={"fitColumns"}
                      />
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

      </div>
    </div>
  );
};

export default ProtocolFormData;

const useStyles = makeStyles({
  productPageTitle: {
    marginTop: "60px",
    color: "white",
    padding: "10px",
  },
  tableContainer: {
    backgroundColor: "whitesmoke",
    borderRadius: "10px",
    padding: "2rem",
    color: "black",
  },
  fullWidth: {
    width: "100%",
  },
});
